var _rect, _path, _path2, _rect2, _circle, _path3;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 55,
    x: 8.5,
    y: 19.5,
    fill: "#F7F7F9",
    stroke: "#9B9BAB",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9BAB",
    d: "M9 70h82v4H9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#686982",
    d: "M51 72.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M46 75h8v5h-8z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 2,
    x: 27,
    y: 80,
    fill: "#686982",
    rx: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.313,
    cy: 45.313,
    r: 8.438,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#36CF8A",
    fillRule: "evenodd",
    d: "M55.403 40.787a1.4 1.4 0 0 0-1.955.31l-4.476 6.164-2.41-2.444a1.4 1.4 0 1 0-1.994 1.965l3.57 3.62a1.4 1.4 0 0 0 2.129-.16l5.446-7.5a1.4 1.4 0 0 0-.31-1.955M60 55H50c-5.514 0-10-4.486-10-10s4.486-10 10-10 10 4.486 10 10z",
    clipRule: "evenodd"
  })));
});
const SvgDesktop = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDesktop);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjguNSIgeT0iMTkuNSIgd2lkdGg9IjgzIiBoZWlnaHQ9IjU1IiByeD0iMS41IiBmaWxsPSIjRjdGN0Y5IiBzdHJva2U9IiM5QjlCQUIiLz4KPHJlY3QgeD0iOSIgeT0iNzAiIHdpZHRoPSI4MiIgaGVpZ2h0PSI0IiBmaWxsPSIjOUI5QkFCIi8+CjxwYXRoIGQ9Ik01MSA3Mi41QzUxIDczLjA1MjMgNTAuNTUyMyA3My41IDUwIDczLjVDNDkuNDQ3NyA3My41IDQ5IDczLjA1MjMgNDkgNzIuNUM0OSA3MS45NDc3IDQ5LjQ0NzcgNzEuNSA1MCA3MS41QzUwLjU1MjMgNzEuNSA1MSA3MS45NDc3IDUxIDcyLjVaIiBmaWxsPSIjNjg2OTgyIi8+CjxyZWN0IHg9IjQ2IiB5PSI3NSIgd2lkdGg9IjgiIGhlaWdodD0iNSIgZmlsbD0iIzY4Njk4MiIvPgo8cmVjdCB4PSIyNyIgeT0iODAiIHdpZHRoPSI0NiIgaGVpZ2h0PSIyIiByeD0iMC41IiBmaWxsPSIjNjg2OTgyIi8+CjxjaXJjbGUgY3g9IjUwLjMxMjUiIGN5PSI0NS4zMTI1IiByPSI4LjQzNzUiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNTUuNDAzMiA0MC43ODdDNTQuNzc4NCA0MC4zMzI0IDUzLjkwMjggNDAuNDY5OSA1My40NDgyIDQxLjA5NzFMNDguOTcyIDQ3LjI2MTFMNDYuNTYxNyA0NC44MTczQzQ2LjAxODggNDQuMjY2NiA0NS4xMzMxIDQ0LjI2MDQgNDQuNTgyNSA0NC44MDMyQzQ0LjAzMTggNDUuMzQ2IDQ0LjAyNTYgNDYuMjMyNSA0NC41Njg0IDQ2Ljc4MjNMNDguMTM3OCA1MC40MDE4QzQ4LjQwMTggNTAuNjY5NyA0OC43NjExIDUwLjgxODggNDkuMTM0NCA1MC44MTg4QzQ5LjE2OTYgNTAuODE4OCA0OS4yMDQ3IDUwLjgxNzMgNDkuMjM5OSA1MC44MTVDNDkuNjQ5OSA1MC43ODM3IDUwLjAyNTYgNTAuNTc0NCA1MC4yNjcgNTAuMjQxNkw1NS43MTMzIDQyLjc0MTlDNTYuMTY3OCA0Mi4xMTY0IDU2LjAyODggNDEuMjQxNiA1NS40MDMyIDQwLjc4N1pNNjAgNTVINTBDNDQuNDg1OSA1NSA0MCA1MC41MTQgNDAgNDVDNDAgMzkuNDg1OSA0NC40ODU5IDM1IDUwIDM1QzU1LjUxNDEgMzUgNjAgMzkuNDg1OSA2MCA0NVY1NVoiIGZpbGw9IiMzNkNGOEEiLz4KPC9zdmc+Cg==";